import { render, staticRenderFns } from "./CustomAttributeFilter.vue?vue&type=template&id=ffe20e36&"
import script from "./CustomAttributeFilter.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports